/**
 * Wersja tekstu zgody rodzica na zapisywanie nagrań głosu dziecka (SPEC §23.40.9). Zgoda jest przypisana do konkretnego tekstu, bo od tekstu zależy, co wolno z nagraniem zrobić:
 *   1 — nagranie i odpowiedzi Azure zostają w prywatnym buckecie Cloudflare (tekst z §23.39 i §23.40 do zadania „Kalibracja”);
 *   2 — dodatkowo nagrania wolno pobrać do prywatnego repozytorium GitHuba, przepuścić przez silniki rozpoznawania uruchamiane na serwerze GitHuba (Whisper, wav2vec2)
 *       i pokazać deweloperowi (Claude) wraz z raportem.
 * Zadanie „Kalibracja” przetwarza tylko nagrania nagrane pod zgodą w wersji nie niższej niż ta stała. Podnosząc ją, trzeba zmienić tekst w oknie zgody (src/ui/adminProfiles.ts).
 */
export const RECORDING_CONSENT_VERSION = 2;
